import { listImageAPI } from '@/service';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { queryClient } from '@configuration/queryClient.config';
import { ImageTypeDTO } from '@/model';

const listImageBaseQueryKey = 'listImage';
const listImageQueryKey = (elementTypes?: ImageTypeDTO[], layoutId?: number) => [
  listImageBaseQueryKey,
  elementTypes,
  layoutId,
];

const listImageFetchFunction = listImageAPI;

export const listImageQueryOptions = (elementTypes?: ImageTypeDTO[], layoutId?: number) =>
  queryOptions({
    queryKey: listImageQueryKey(elementTypes, layoutId),
    queryFn: () => listImageFetchFunction(elementTypes, layoutId),
  });

export const useListImageQuery = (elementTypes?: ImageTypeDTO[], layoutId?: number) => {
  return useQuery(listImageQueryOptions(elementTypes, layoutId));
};

export const invalidateListImageQuery = async () =>
  queryClient.invalidateQueries({
    queryKey: [listImageBaseQueryKey],
  });
